export const FEATURE_ITEMS = [
  {
    title: 'The Essentials',
    items: [
      {
        icon: 'icon-31',
        title: 'Drag & Drop Editor',
        text:
          'Build your website the way you want it. Simply drop in your logo, photos, text and videos. No creative limits or coding needed!',
      },
      {
        icon: 'icon-32',
        title: '100+ Website Templates',
        text:
          'Choose from a huge range of industry&#8209;specific website templates and customize everything to suit your brand.',
      },
      {
        icon: 'icon-33',
        title: ' Your Own Domain',
        text:
          'Connect any domain name to your website from any provider or use our custom free domains.',
      },
      {
        icon: 'icon-34',
        title: 'Mobile&#8209;Friendly',
        text:
          'Your website will look great on any device. Our templates are 100% responsive to all devices, including smartphones, tablets and desktops.',
      },
      {
        icon: 'icon-35',
        title: 'Content Blocks',
        text:
          "Don't waste time with content layouts. Build each page from a wide range of stunning, pixel&#8209;perfect pre&#8209;designed content blocks.",
      },
      {
        icon: 'icon-36',
        title: 'Fast Website Loading',
        text:
          'Your website will be automatically optimized for fast loading no matter where your visitors are.',
      },
      {
        icon: 'icon-37',
        title: 'One&#8209;Page Websites',
        text:
          'All our multi&#8209;page templates come in a single&#8209;page version, making it even easier to get your business online faster.',
      },
      {
        icon: 'icon-38',
        title: 'Unlimited Pages',
        text:
          "Don't be restricted &ndash; build your website the way you want it! Enjoy unlimited pages, photos, videos and much more…",
      },
      {
        icon: 'icon-39',
        title: 'AutoSave & Backup',
        text:
          'Be sure not to lose any of your work with real&#8209;time saving. The Editor automatically saves everything while you work.',
      },
      {
        icon: 'icon-40',
        title: 'Color Wizard',
        text:
          'Save time trying to match your brand colors with your template. Just upload any theme image or logo and extract/preset all your new template colors.',
      },
      {
        icon: 'icon-41',
        title: 'Mobile Editing',
        text:
          'Update your website from any mobile device. Edit all your content and photos quickly and easily.',
      },
      {
        icon: 'icon-42',
        title: 'Custom Code',
        text:
          'Want to get techy and add your own code? Siteplus lets you break the mold and allows you to add your own custom code functionality to any block.',
      },
    ],
  },
  {
    title: 'Photos & Videos',
    items: [
      {
        icon: 'icon-43',
        title: 'Photo Editor',
        text:
          'Add your own photos and edit them with the built&#8209;in photo editor. Crop images, add overlays, effects, filters and more.',
      },
      {
        icon: 'icon-44',
        title: 'Video',
        text:
          'Give your visitors a visual experience by embedding YouTube or Vimeo videos into your website.',
      },
      {
        icon: 'icon-45',
        title: 'Unlimited Icons',
        text:
          'Search and choose from a million icons to help you visually represent information.',
      },
      {
        icon: 'icon-46',
        title: 'Photo Gallery',
        text:
          'Showcase your work, products or family photos on any page with over 30 eye-catching photo galleries.',
      },
      {
        icon: 'icon-47',
        title: 'Free Stock Images',
        text:
          'Bring your website to life with a selection of over 200,000 professional premium photos in high&#8209;resolution.',
      },
      {
        icon: 'icon-48',
        title: 'Photo Slideshows',
        text:
          'Add your photos and captions to create a stylish slideshow. Available with full control slideshow speed and autoplay options.',
      },
      {
        icon: 'icon-49',
        title: 'Image Optimization',
        text:
          'All images are automatically optimized and resized for faster speeds, based on the user’s device.',
      },
      {
        icon: 'icon-50',
        title: 'Photo Upload',
        text:
          'Add your photos directly from your computer or connect with your Dropbox, Google Drive, Instagram or Facebook library.',
      },
    ],
  },
  {
    title: 'Social & Blogs',
    items: [
      {
        icon: 'icon-51',
        title: 'Social Buttons',
        text:
          'Encourage your visitors to like and share your content by adding icons for social media platforms such as Facebook, Twitter, LinkedIn and Pinterest to your site.',
      },
      {
        icon: 'icon-52',
        title: 'Facebook Comments',
        text:
          'Give visitors the option to comment on your linked Facebook page without leaving the website.',
      },
      {
        icon: 'icon-53',
        title: 'Instagram Connect',
        text:
          'Automatically showcase your Instagram photos on your website every time you post.',
      },
      {
        icon: 'icon-54',
        title: 'Blogging',
        text:
          'Share your story and connect with your visitors by adding a customizable blog to your website.',
      },
      {
        icon: 'icon-55',
        title: 'Twitter Connect',
        text:
          'Keep your site visitors updated by displaying a live Twitter feed from your Twitter account.',
      },
      {
        icon: 'icon-56',
        title: 'Facebook Like',
        text:
          'Enable your visitors to like your business Facebook page without leaving the website.',
      },
    ],
  },
  {
    title: 'Forms & Maps',
    items: [
      {
        icon: 'icon-57',
        title: 'Form Builder',
        text:
          'Use the simple form builder to create custom forms with opt-in consent fields, drop-down selection options and more.',
      },
      {
        icon: 'icon-58',
        title: 'Password Login',
        text:
          'Add password access to web pages so that they are only visible to people you choose.',
      },
      {
        icon: 'icon-59',
        title: 'Google Maps',
        text:
          'Display your location with interactive maps and give your customers simple directions to your business.',
      },
      {
        icon: 'icon-60',
        title: 'Contact Form',
        text:
          'Add a contact inquiry form for visitors to get in touch with you or request additional information.',
      },
      {
        icon: 'icon-61',
        title: 'Subscribe Form',
        text:
          'Add a mailing list subscription box or integrate directly with Mailchimp newsletter services.',
      },
    ],
  },
  {
    title: 'Online Store',
    items: [
      {
        icon: 'icon-62',
        title: 'One Click Setup',
        text:
          'Drag and drop the Online Store into your existing website, add your products and start selling.',
      },
      {
        icon: 'icon-63',
        title: 'Secure Payments',
        text:
          'Accept credit cards instantly or connect with PayPal, Square, Stripe and many more payment providers.',
      },
      {
        icon: 'icon-64',
        title: 'Gift Cards & Vouchers',
        text:
          'Create vouchers or gift cards by applying customizable promotional codes to increase sales.',
      },
      {
        icon: 'icon-65',
        title: 'Smart Shipping',
        text:
          'Ship products anywhere with real-time shipping rates dynamically created based on carrier, location, weight and quantity.',
      },
      {
        icon: 'icon-66',
        title: 'Tax Calculation',
        text:
          'Save yourself the hassle of having to crunch the numbers. Apply automatic tax calculations for all countries.',
      },
      {
        icon: 'icon-67',
        title: 'Inventory Control',
        text:
          'Manage and track your inventory with inbuilt inventory management to help grow your online store.',
      },
      {
        icon: 'icon-68',
        title: 'Sell on Mobile',
        text:
          'Your Online Store will be fully responsive, meaning your customers can buy from any mobile device.',
      },
      {
        icon: 'icon-69',
        title: 'Easy Checkout',
        text:
          'Give customers a faster and easier checkout with optional registration during check out.',
      },
      {
        icon: 'icon-70',
        title: 'Customer Address Book',
        text:
          'Allow customers to save their delivery addresses in their profile for future orders.',
      },
      {
        icon: 'icon-71',
        title: 'Product Pages',
        text:
          'Choose from multiple product page layouts and customize the descriptions and designs as you wish.',
      },
      {
        icon: 'icon-72',
        title: 'Display Discounts',
        text:
          'Increase your conversions by showing regular prices alongside discounted prices.',
      },
      {
        icon: 'icon-73',
        title: 'Product Categories',
        text:
          'Make it easier for customers to find products by organizing them into categories.',
      },
    ],
  },
  {
    title: 'Marketing',
    items: [
      {
        icon: 'icon-74',
        title: 'Website Stats',
        text:
          'View how many visits your website gets, where your visitors are from, which pages are most popular and much more.',
      },
      {
        icon: 'icon-75',
        title: 'Customize Page URLs',
        text:
          'Improve search engine visibility and show your customers where they are on your site by customizing each page URL.',
      },
      {
        icon: 'icon-76',
        title: 'Google Approved',
        text:
          'Your website will be automatically optimized for Google PageSpeed to improve your ranking.',
      },
      {
        icon: 'icon-77',
        title: 'Search Engine Optimize',
        text:
          'Easily optimize your site for SEO with page titles, image tags and meta descriptions to help search engines find you.',
      },
      {
        icon: 'icon-78',
        title: 'Google Analytics',
        text:
          'Connect your website with Google Analytics easily by adding your code.',
      },
    ],
  },
];
